var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article-layout',[_c('h1',[_vm._v("Verzonden")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Naar home")]),_c('h2',[_vm._v("Bedankt voor uw reactie!")]),_c('p',[_vm._v("\n      Wij hebben uw reactie ontvangen en nemen zo spoedig mogelijk contact met u op. Dit kan enkele dagen duren.\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }